// TODO: Remove from `core-js@4`
require('../modules/esnext.string.match-all');



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/proposals/string-match-all.js